import { useState, useEffect } from 'react';
import { getAdminRally } from '../../../api/admin/rallies';
import { useAppDispatch } from '../../../store';
import { setAdminRally } from '../../../store/adminSlices/rallies';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
const useRallyFormState = (rallyId) => {
    const dispatch = useAppDispatch();
    const [internalTitle, setInternalTitle] = useState('');
    const [titleTranslations, setTitleTranslations] = useState({ de: '', en: '', cs: '' });
    const [descriptionTranslations, setDescriptionTranslations] = useState({
        de: '',
        en: '',
        cs: '',
    });
    const [badge, setBadge] = useState(null);
    const [image, setImage] = useState(null);
    const [minutes, setMinutes] = useState('');
    const [isTeamRally, setIsTeamRally] = useState(false);
    const [isLinearRally, setIsLinearRally] = useState(false);
    const [isPublicRally, setIsPublicRally] = useState(false);
    const [isRallyTimeLimit, setIsRallyTimeLimit] = useState(false);
    const [selectedThemes, setSelectedThemes] = useState([]);
    const [selectedTargetGroups, setSelectedTargetGroups] = useState([]);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [isFormStateReady, setIsFormStateReady] = useState(!rallyId);
    const [updatedFormFields, setUpdatedFormFields] = useState(() => new Set());
    useEffect(() => {
        if (rallyId) {
            const fetchRally = async () => {
                try {
                    const rally = await getAdminRally(rallyId);
                    dispatch(setAdminRally(rally));
                    setInternalTitle(rally.internalTitle);
                    setTitleTranslations(rally.title);
                    setDescriptionTranslations(rally.description);
                    setBadge(rally.badge);
                    setImage(rally.image || null);
                    setMinutes(String(rally.maxDuration));
                    setIsLinearRally(rally.isLinear);
                    setIsPublicRally(rally.visibility === 'public');
                    setIsTeamRally(rally.isTeamRally);
                    setIsRallyTimeLimit(rally.isTimeLimit);
                    setSelectedThemes(rally.themes.map((theme) => theme.id));
                    setSelectedTargetGroups(rally.targetGroups.map((targetGroup) => targetGroup.id));
                    setLatitude(rally.latitude ?? null);
                    setLongitude(rally.longitude ?? null);
                    setIsFormStateReady(true);
                }
                catch (error) {
                    dispatch(setIsModalOpen(true));
                    dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
                }
            };
            fetchRally();
        }
    }, []);
    return {
        formState: {
            internalTitle,
            setInternalTitle,
            titleTranslations,
            setTitleTranslations,
            descriptionTranslations,
            setDescriptionTranslations,
            badge,
            setBadge,
            image,
            setImage,
            minutes,
            setMinutes,
            isTeamRally,
            setIsTeamRally,
            isLinearRally,
            setIsLinearRally,
            isPublicRally,
            setIsPublicRally,
            isRallyTimeLimit,
            setIsRallyTimeLimit,
            selectedThemes,
            setSelectedThemes,
            selectedTargetGroups,
            setSelectedTargetGroups,
            latitude,
            setLatitude,
            longitude,
            setLongitude,
        },
        updatedFormFields,
        setUpdatedFormFields,
        isFormStateReady,
    };
};
export default useRallyFormState;
